import { Container, Select, Spinner } from './Main.styles'
import { useBmsAuth } from './useBmsAuth'
import { BmsTag, useProductTags } from './useProductTags'
import React, { useState, useEffect } from 'react'

const Main = ({ plugin }: any) => {
   const fieldValue = plugin.getFieldValue(plugin.fieldPath)
   const [pluginLoading, setPluginLoading] = useState(true)

   // state
   const [field, setField] = useState<BmsTag>(null);
   // plugin configuration variables
   const username = plugin.parameters.global.bmsApiUser
   const password = plugin.parameters.global.bmsApiPassword
   const endpoint = plugin.parameters.global.bmsApiEndpoint

   // hooks
   const token = useBmsAuth({ endpoint, username, password })
   const { tags, fetchTags, loading } = useProductTags({ endpoint })

   // lifecycle methods
   useEffect(() => {
      if (typeof fieldValue !== 'undefined') {
         setField(JSON.parse(fieldValue))
         setPluginLoading(false)
      }
   }, [fieldValue])

   useEffect(() => {
      if (token) {
         fetchTags(token)
      }
   }, [token])

   useEffect(() => {
      const unsubscribe = plugin.addFieldChangeListener(plugin.fieldPath, (newValue: any) => {
         setField(JSON.parse(newValue));
      });
      return () => {
         unsubscribe();
      };
   }, [token]);

   const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
      // find the selected tag and set it to the plugin field value
      const { id, name } = tags.find(tag => tag.id === Number(event.target.value))
      plugin.setFieldValue(plugin.fieldPath, JSON.stringify({ id, name }));
   }
   console.log(field)
   return <Container>
      {(loading || pluginLoading) && <Spinner>Loading tags please wait...</Spinner>}
      {!(loading || pluginLoading) && <Select
         key={field?.id}
         defaultValue={String(field?.id ?? '')}
         required
         onChange={handleChange}>
         <option disabled value=''>-- Select a tag --</option>
         {tags.map((tag) => <option
            key={tag.id}
            selected={field?.id === tag.id}
            value={String(tag.id)}>
            {tag.name}
         </option>)}
      </Select>}
   </Container>
}

export default Main;
